import { useShallow } from 'zustand/react/shallow';
import useModalStore from './store';

export const useModal = () =>
  useModalStore(
    useShallow((state) => ({
      createModal: state.createModal,
      destroyModal: state.destroyModal,
      createCustomModal: state.createCustomModal,
    })),
  );

export default useModal;
